<template>
  <div class="rodemap">
    <div class="mask05"></div>
    <QuestionJigsaw :data="data" @jump="jump" @finish="finish"></QuestionJigsaw>
  </div>
</template>

<script>
//script
import Tools from "../../../scripts/tools";
import { gsap } from "gsap";
//Global
import Global from "../../../scripts/Global";
import QuestionJigsaw from "../../cmp/questionJigsaw";

export default {
  data() {
    return {
      data: {
        headTipImg: "苏尚卿讲解",
        headTipTxt: "我来吧",
        headTipPathTxt: "前往浮碧亭 >>",
        headTipPath: "/rodemap/ssq/07.5",

        qText: "以图片选择的方式，完成拼图小游戏！拼出万春亭藻井画",
        qImg: "万春亭配图",
        errText: "以图片选择的方式，完成拼图小游戏！拼出万春亭藻井画",
        answerArr: [
          {
            img: "万春亭配图1"
          },
          {
            img: "万春亭配图2",
            right: true
          },
          {
            img: "万春亭配图3"
          }
        ]
      }
    };
  },
  components: {
    QuestionJigsaw
  },
  created() {},
  computed: {},
  methods: {
    finish(event) {
      if (event) {
        Global.startPlay("ssq", "scene10");
      } else {
        Global.startPlay("ssq", "scene11");
      }
    },
    jump(event) {
      if (event) {
        Global.curr = {
          ...this.data,
          headTipImg: "苏尚卿讲解",
          headTipTxt: "辛苦啦！我们去前面的亭子休息一下！",
          headTipPath: "/rodemap/ssq/07.5",
          headTipPathTxt: "前往浮碧亭 >>",
          ybtxt: "",
          textCfg: {
            "text-align": "center"
          },
          headTipStyle: {
            bottom: "0rem"
          },
          bg: "万春亭"
        };
        Global.yubi.ssq.b3 = true;
        this.$router.replace("/yu");
      } else {
        this.$router.replace("/rodemap/ssq/07.5");
      }
      console.log(event, "event");
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.rodemap {
  background-image: url(//cdn.original-fun.com/gugong/万春亭.jpg);
  background-position: center;
  width: 100vw;
  height: 100vh;
  max-width: 75vh;
  margin: 0 auto;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
